import React from 'react';

//returns the body text  under 'Details'. Here 
//parsing the body paragraph text and list items text to show  in DOM
const BodyText = ({text}) => {

    const bodyText = new DOMParser().parseFromString(text, "text/html");

    const list = [];
    const para = [];
    for (let elem of bodyText.getElementsByTagName('p')) {
        para.push(elem.innerText);
    }
    for (let elem of bodyText.getElementsByTagName('li')) {
        list.push(elem.innerText);
    }

    return (
        <div className='body-text'>
            <div className='detail-text'> DETAILS </div>
            <hr />
            <div className='body-text-para'>
                {para.map(x => {
                    return <p> {x} </p>
                })}
            </div>
            <ul className='body-text-list'>
                {list.map(x => {
                    return <li> {x} </li>
                })}
            </ul>
        </div>
    )
}

export default BodyText;


// WEBPACK FOOTER //
// ./src/components/body-text.js